import { render, staticRenderFns } from "./BaseUserAvatar.vue?vue&type=template&id=71b6ef77&"
import script from "./BaseUserAvatar.vue?vue&type=script&lang=js&"
export * from "./BaseUserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports